import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Backdrop, Box, Button, CircularProgress, Grid2 } from '@mui/material';
import { BOX_SHADOW } from '../../shared/constants';
import { useCityListWithoutState, useCourseApartmentList, useCourseDetail, useNewCourseDetail, usePriceCourseDetail } from '../../assets/api/useGetApi';
import { useNavigate, useParams } from 'react-router-dom';
import { TextSkeleton } from '../../shared/utils/SkeletonCom';

import { FormAutoComplete } from '../../shared/components/FormFields/FormAutoComplete';
import { useDialog } from '../../shared/hook/useDialog';
import MainDialogBox from '../../shared/components/Dialog/DialogMainBox';
import { ImgText } from '../../shared/utils/Heading';
import { OrDivider } from '../../shared/utils/CustomDivider';
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import useResponsive from '../../shared/utils/Responsive'
import usePriceStore from '../../shared/store/usePriceStore';
import { PriceUi } from "./SubscribedCardTypeThree"
import CouponBoxUi from '../../shared/utils/CouponBoxUi';
import { useCoursePayment } from '../../shared/utils/useCoursePayment';
import { useCourseFreePayment } from '../../shared/utils/useCourseFreePayment';
import useCouponStore from '../../shared/store/useCouponStore';
import { AutoCompleteField } from '../../shared/components/FormFields/AutoCompleteField';
import { formatToYYYYMMDD } from '../../shared/formatter';
import useAuthStore from '../../shared/store/useAuthStore';



export const FullScreenLoader = ({ open }) => (
    <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={open}
    >
        <CircularProgress color="inherit" />
    </Backdrop>
);

const SubscribedCard = ({ course_id }) => {
    const [selectedApartment, setSelectedApartment] = React.useState({})
    const [isProcessing, setIsProcessing] = React.useState(false);
    const { couponData } = useCouponStore();
    const isSmallScreen = useResponsive("sm")
    const setPriceDetail = usePriceStore((state) => state.setPriceDetail);
    const [searchCity, setSearchCity] = React.useState("")
    const { data: cityList, isLoading: isCityLoading } = useCityListWithoutState({ search: searchCity })
    const { slug, apartment, title, apartments_id } = useParams();
    const { data: newCourse } = useNewCourseDetail({ slug: slug });
    const [cityId, setCityId] = React.useState("")
    const { data: coursePriceDetail, isLoading: isPriceDetailIsLoading } = usePriceCourseDetail({
        apartmentName: apartment,
        title: title
    });
    React.useEffect(() => {
        setPriceDetail(coursePriceDetail?.data);
    }, [coursePriceDetail])

    const token = useAuthStore((state) => state.accessToken);

    const { open: openDialog, handleClickOpen, handleClose } = useDialog();
    const { data: coursesApartmentList, isLoading: isLoadingApartmentList } = useCourseApartmentList({
        "course_slug": slug,
        city_id: cityId || newCourse?.data?.locations?.city?.id
    });
    const navigate = useNavigate();
    const { data: coursesDetail, isLoading } = useCourseDetail(slug);

    const apartmentOptions = coursesApartmentList?.data?.map((apartment, index) => ({
        id: apartment?.id,
        label: apartment?.apartment_name,
        value: apartment?.apartment_name,
    })) || []

    const CityOptions = cityList?.data?.map((city) => ({
        id: city?.id,
        label: city?.city_name,
        value: city?.city_name,
    })) || []

    const paymentHook = couponData?.finalPrice === 0 ? useCourseFreePayment : useCoursePayment;
    const finalCourseId = course_id || coursesDetail?.data?.id || newCourse?.data?.id;

    const { handlePayment, SuccessDialog } = paymentHook({
        course_id: finalCourseId,
        course_Name: title,
        apartment_name: coursePriceDetail?.data?.apartment_name,
        coverImage: coursesDetail?.data?.cover_image,
        apartments_id: coursePriceDetail?.data?.apartments_id,
        batch_id: null,
        start_date: coursePriceDetail?.data?.start_date,
        end_date: coursePriceDetail?.data?.end_date,
        onProcessingChange: setIsProcessing

    });

    const validationSchema = yup.object().shape({
        apartment: yup.string().required('Apartment is required'),
    });

    const handleSubmit = (values) => {
        navigate(`/CoursesDetail/${slug}/${selectedApartment?.id}/${coursesDetail?.data?.title}/${values?.apartment}`);
        handleClose()
    };

    React.useEffect(() => {
        setSearchCity(newCourse?.data?.locations?.city?.city_name)
    }, [newCourse?.data])

    return (
        <>
            <FullScreenLoader open={isProcessing} />
            <Card
                sx={{
                    boxShadow: BOX_SHADOW,
                    border: "1px solid #F0F0F0",
                    p: "32px 22px",
                    borderRadius: isSmallScreen ? "10px" : "40px",
                    position: isSmallScreen ? "fixed" : "relative",
                    bottom: "0",
                    bgcolor: "#fff",
                    zIndex: 100,
                    width: isSmallScreen ? "90%" : "auto",
                }}>

                {
                    !isSmallScreen && <>
                        <CardContent>
                            {(title && apartment) && (
                                <>

                                    <PriceUi totalPrice={coursePriceDetail?.data?.course_fees} />

                                    <Box
                                        sx={{
                                            border: "0.5px solid #000000",
                                            borderRadius: "40px",
                                            my: 4
                                        }}
                                    >
                                        <Grid2 container>
                                            <Grid2 children size={6} sx={{ borderRight: "0.5px solid #000000", p: 3 }}>

                                                <Typography variant="body2" >Start Date</Typography>
                                                {isPriceDetailIsLoading && <TextSkeleton width={100} line={1} />}
                                                {!isPriceDetailIsLoading && <Typography variant="body2" fontSize={"12px"}>{formatToYYYYMMDD(coursePriceDetail?.data?.start_date)}</Typography>}

                                                <Typography variant="body2" mt={0.5}>Start Time</Typography>
                                                {isPriceDetailIsLoading && <TextSkeleton width={100} line={1} />}
                                                {!isPriceDetailIsLoading && <Typography variant="body2" fontSize={"12px"}>{coursePriceDetail?.data?.start_time}</Typography>}

                                            </Grid2>
                                            <Grid2 children size={6} sx={{ p: 3 }}>
                                                <Typography variant="body2">End Date</Typography>

                                                {isPriceDetailIsLoading && <TextSkeleton width={100} line={1} />}
                                                {!isPriceDetailIsLoading && <Typography variant="body2" fontSize={"12px"}>{formatToYYYYMMDD(coursePriceDetail?.data?.end_date)}</Typography>}

                                                <Typography variant="body2" mt={0.5}>End Time</Typography>

                                                {isPriceDetailIsLoading && <TextSkeleton width={100} line={1} />}
                                                {!isPriceDetailIsLoading && <Typography variant="body2" fontSize={"12px"}>{coursePriceDetail?.data?.end_time}</Typography>}
                                            </Grid2>
                                        </Grid2>

                                    </Box>
                                </>
                            )

                            }
                            <Button variant="contained" fullWidth
                                onClick={(title && apartment) ? handlePayment : handleClickOpen}
                            >
                                {(title && apartment) ? "Purchase Now" : "Enroll Now"}
                            </Button>

                            {
                                apartments_id && <CouponBoxUi totalPrice={coursePriceDetail?.data?.course_fees} />
                            }
                        </CardContent>
                    </>
                }

                {
                    isSmallScreen && <>
                        <CardContent sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
                            {(title && apartment) && (
                                <>


                                    <PriceUi totalPrice={coursePriceDetail?.data?.course_fees} />
                                </>
                            )

                            }
                            <Button variant="contained" fullWidth
                                onClick={(title && apartment) ? handlePayment : handleClickOpen}
                            >
                                {(title && apartment) ? "Purchase Now" : "Enroll Now"}
                            </Button>

                            {
                                apartments_id && <CouponBoxUi totalPrice={coursePriceDetail?.data?.course_fees} />
                            }
                        </CardContent>
                    </>
                }


            </Card>
            <MainDialogBox open={openDialog} handleClose={handleClose} width={"50%"}>

                <Box sx={{ display: 'flex', flexDirection: "column", alignItems: "center" }}>

                    <ImgText text={"We’d love to know your preference!"} sx={{ fontSize: "30px" }} />
                    <Typography variant='body2' textAlign={"center"} my={1}>Which location would you prefer to attend the Course at? Please select your preferred option below.</Typography>
                    <Box my={4} width={"60%"}>
                        <Formik
                            initialValues={{ apartment: "", city_id: newCourse?.data?.locations?.city?.id }}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}

                        >
                            {() => (
                                <Form>
                                    <Grid2 container spacing={2}>
                                        <Grid2 children size={{ xs: 12, sm: 12 }}>
                                            <Field
                                                name="city_id"
                                                component={AutoCompleteField}
                                                options={CityOptions}
                                                label="City"
                                                isRequired={true}
                                                isLoading={isCityLoading}
                                                nooptionText={"Currently Unavailable"}
                                                onValueChange={(val) => {
                                                    setCityId(val?.id)
                                                }}
                                                onSearchChange={(val) => {
                                                    setSearchCity(val)
                                                }}


                                            />
                                        </Grid2>
                                        <Grid2 children size={{ xs: 12, sm: 12 }}>
                                            <Field
                                                name="apartment"
                                                component={AutoCompleteField}
                                                options={apartmentOptions}
                                                label="Apartment"
                                                isRequired={true}
                                                isLoading={isLoadingApartmentList}
                                                nooptionText={"Currently Unavailable"}
                                                isShow={true}
                                                isStoredId={false}
                                                onValueChange={(val) => {
                                                    setSelectedApartment(val)
                                                }}

                                            />
                                        </Grid2>

                                        <Grid2 children size={{ xs: 12, sm: 12 }}>
                                            <Button variant='contained' fullWidth type="submit">Verify</Button>

                                        </Grid2>
                                    </Grid2>

                                </Form>
                            )}
                        </Formik>
                    </Box>

                    {
                        !token && <>

                            <OrDivider text={"Sign in for a better experience!"} />
                            <Typography variant='h6' fontSize={"12px"} color='grey.100' >Get personalized event updates, faster check-in, and exclusive perks.</Typography>
                        </>
                    }


                </Box>


            </MainDialogBox>

            <SuccessDialog />
        </>

    )
}

export default SubscribedCard